import { CompanyListCompanyDto, CompanySearchDto } from 'models/dtoTypes';
import CompanyGenericSearchDialog from 'kosmos/components/CompanyGenericSearchDialog';

export interface IField {
  required?: boolean;
  label: string;
  widget: string;
  name: string;
  description?: string;
  options?: { value: string; label: string }[];
  placeholder?: string;
}

interface Props {
  selectedCompanyListItem?: CompanyListCompanyDto;
  open: boolean;
  onClose: () => void;
  onSelect: (companyListItemId: string, companyIds: string[]) => Promise<void>;
}

function SearchCompanyDialog(props: Props): JSX.Element {
  const { selectedCompanyListItem, open, onClose, onSelect } = props;
  const handleClose = () => {
    onClose();
  };

  async function handleFinishSelect(company: CompanySearchDto) {
    const companyId = company.id || '';
    await onSelect(selectedCompanyListItem?.id || '', [companyId]);
    onClose();
  }

  const renderCardContent = () => {
    return (
      <CompanyGenericSearchDialog
        initialCompanyNumber={selectedCompanyListItem?.registrationNumbers || ''}
        initialCompanyName={selectedCompanyListItem?.name || ''}
        initialCountry={selectedCompanyListItem?.countryCode || ''}
        initialAddressLine={selectedCompanyListItem?.address || ''}
        initialPostalCode={selectedCompanyListItem?.postalCode || ''}
        onClose={handleClose}
        onSelectCompany={handleFinishSelect}
        open={open}
      />
    );
  };

  return open ? renderCardContent() : <></>;
}

export default SearchCompanyDialog;
